export default __webpack_public_path__ + "static/media/ScreenShot_4.a8b9971c.jpg";